import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { ProductService } from '../../../../../../admin/src/app/services/product.service';
import { TechnicalSheetEntry } from '../../../../../../admin/src/app/models/technical-sheet-entry';
import { MatomoTracker } from 'ngx-matomo';

@Component({
  selector: 'app-product-technical-sheet',
  templateUrl: './product-technical-sheet.component.html',
  styleUrls: ['./product-technical-sheet.component.css']
})
export class ProductTechnicalSheetComponent implements OnInit, OnDestroy {

  productId: string;

  entries: TechnicalSheetEntry[];

  sub: Subscription;

  constructor(
    private route: ActivatedRoute,
    private productSvc: ProductService,
    private translate: TranslateService,
    private matomoTracker: MatomoTracker
  ) { }

  ngOnInit() {
    this.matomoTracker.trackPageView('Product technical sheet');

    this.sub = this.route.parent.paramMap.subscribe(params => {
      this.productId = params.get('productId');
      this.getTechnicalSheet();
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  getTechnicalSheet() {
    this.productSvc.getTechnicalSheet(this.productId).subscribe(data => {
      let lang = this.translate.currentLang;
      let defaultLang = this.translate.defaultLang;
      this.entries = Object.assign([], data.payload.elements.filter(e => e.lang === lang));
      if (!this.entries || !this.entries.length) {
        this.entries = Object.assign([], data.payload.elements.filter(e => e.lang === defaultLang));
      }

      this.entries.sort((i1: TechnicalSheetEntry, i2: TechnicalSheetEntry) => {
        return i1.index > i2.index ? 1 : -1;
      });
    });
  }

  getFilename(url: string) {
    const index = url.lastIndexOf('/');
    if (index === -1) {
      return url;
    }
    return url.substring(index + 1);
  }

}
